import { makeStyles } from "@material-ui/core/styles";

const destinationStyles = makeStyles((theme) => ({
  searchBoxGrid: {
    width: "80%",
    height: "100%",
    background: "#EFEFEF",
    borderRadius: "10px",
  },
}));

export default destinationStyles;
